<template>
    <el-dialog
        :model-value="props.visible"
        title="本年允许抵免专用设备投资额"
        width="900"
        top="6vh"
        destroy-on-close
        :close-on-click-modal="false"
        @open="onOpen"
        @closed="closedModal"
    >
        <div v-loading="pageLoading">
            <div class="my-tax-enter-sub-table-wrap">
                <table>
                    <tbody>
                    <tr class="title-row">
                        <td class="title01 center strong" width="60">序号</td>
                        <td class="title01 center strong" width="80">选择</td>
                        <td class="title01 center strong" width="160">代码</td>
                        <td class="title01 center strong" width="420">优惠事项</td>
                        <td class="title01 center strong" width="200">本年累计金额</td>
                    </tr>

                    <tr class="">
                        <td class="title01 center">1</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00100'].checked"
                                :disabled="tableData['DMSE00100'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[0].yhswsx">DMSE00100</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[0].t_yhswsxMc">环境保护专用设备投资抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00100'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00100'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center">2</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00200'].checked"
                                :disabled="tableData['DMSE00200'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[1].yhswsx">DMSE00200</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[1].t_yhswsxMc">节能节水专用设备投资抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00200'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00200'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center">3</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00300'].checked"
                                :disabled="tableData['DMSE00300'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[2].yhswsx">DMSE00300</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[2].t_yhswsxMc">安全生产专用设备投资抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00300'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00300'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center">4</td>
                        <td class="title01 center fxsm_tisi edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00400'].checked"
                                :disabled="tableData['DMSE00400'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[3].yhswsx">DMSE00400</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[3].t_yhswsxMc">
                            环境保护专用设备数字化智能化改造投入抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00400'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00400'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center">5</td>
                        <td class="title01 center fxsm_tisi edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00500'].checked"
                                :disabled="tableData['DMSE00500'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[4].yhswsx">DMSE00500</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[4].t_yhswsxMc">
                            节能节水专用设备数字化智能化改造投入抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00500'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00500'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center">6</td>
                        <td class="title01 center fxsm_tisi edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE00600'].checked"
                                :disabled="tableData['DMSE00600'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[5].yhswsx">DMSE00600</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[5].t_yhswsxMc">
                            安全生产专用设备数字化智能化改造投入抵免企业所得税
                        </td>
                        <td class="right edit" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE00600'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['DMSE00600'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center">7</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['DMSE99999'].checked"
                                :disabled="tableData['DMSE99999'].value != 0 || true"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[6].yhswsx">DMSE99999</td>
                        <td class="title01 ng-binding" ng-bind="dmseGrid.dmseGridlb[6].t_yhswsxMc">
                            其他专用设备投资抵免企业所得税
                        </td>
                        <td class="right read" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['DMSE99999'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                disabled
                                :value-on-clear="0.0"
                                @change="tableData['DMSE99999'].checked = true"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="my-footer">
                <el-button
                    type="primary"
                    @click="onConfirm">确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {cloneDeep} from "lodash";
import Big from "big.js";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    currentData: {
        type: Object,
        default: () => {
        }
    }
})

const initialData = {
    'DMSE00100': {
        name: '环境保护专用设备投资抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE00200': {
        name: '节能节水专用设备投资抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE00300': {
        name: '安全生产专用设备投资抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE00400': {
        name: '环境保护专用设备数字化智能化改造投入抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE00500': {
        name: '节能节水专用设备数字化智能化改造投入抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE00600': {
        name: '安全生产专用设备数字化智能化改造投入抵免企业所得税',
        checked: false,
        value: 0.00,
    },
    'DMSE99999': {
        name: '其他专用设备投资抵免企业所得税',
        checked: false,
        value: 0.00,
    },
}

const pageLoading = ref(false)
const tableData = ref(cloneDeep(initialData))

function onOpen() {
    (props.currentData.subData || []).forEach(it => {
        tableData.value[it.key].value = it.value
        tableData.value[it.key].checked = it.checked
        if (it.disCode != null) {
            tableData.value[it.key].disCode = it.disCode
        }
    })
}

function onConfirm() {
    const resData = []
    let total = new Big(0) // 合计

    Object.keys(tableData.value).forEach(key => {
        if (tableData.value[key].checked) {
            resData.push({
                key,
                ...tableData.value[key],
            })
            total = total.plus(tableData.value[key].value)
        }
    })
    emit('update:visible', false)
    emit('onConfirm', resData, total.times(0.1).toNumber())
}

const emit = defineEmits(['update:visible', 'onConfirm'])

function closedModal() {
    emit('update:visible', false)
    tableData.value = cloneDeep(initialData)
}
</script>

<style scoped lang="scss">
.my-footer {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 30px;
}

.my-tax-enter-sub-table-wrap {
    max-height: calc(80vh - 100px);
    overflow-y: auto;
    padding: 0 10px 3px 10px;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(211, 211, 211, 0.9);
        border-radius: 10px;
    }

    > table {
        border: 1px solid #dcdcdc;
        border-collapse: collapse;

        tr {
            td {
                background-color: #fafafa;
                border: 1px solid #dcdcdc;
                padding: 10px 16px;

                &:nth-child(1) {
                    text-align: center;
                    width: 70px;
                }

                &:nth-child(2) {
                    width: 70px;
                    text-align: center;
                }

                &:nth-child(3) {
                    width: 120px;
                    text-align: center;
                }

                &:last-child {
                    width: 160px;
                    max-width: 160px;
                }
            }

            &.title-row {
                text-align: center;

                td {
                    font-weight: 700;
                }
            }
        }
    }
}

:deep(.left-number-input) {
    &.el-input-number .el-input__inner {
        text-align: left;
    }
}
</style>
